import { isFeatureActive } from "./getFeature";

import MonetaryFormat from "types/MonetaryFormat";

const generateCurrencyValue = (value: number | string, monetarySettings: MonetaryFormat | undefined): string => {
  if (!value && value !== 0) return "";

  let currencyValue;
  const spaceBetweenPriceAndSymbol = isFeatureActive("Add space between price and currency symbol") ? " " : "";

  if (!monetarySettings) {
    currencyValue = typeof value === "string" ? value : value.toFixed(2);
  } else if (monetarySettings.format === "SYMBOL_LEFT") {
    currencyValue = `${monetarySettings.symbol}${spaceBetweenPriceAndSymbol}${
      typeof value === "string" ? value : value.toFixed(monetarySettings.decimalPlaces)
    }`;
  } else {
    currencyValue = `${
      typeof value === "string" ? value : value.toFixed(monetarySettings.decimalPlaces)
    }${spaceBetweenPriceAndSymbol}${monetarySettings.symbol}`;
  }

  if (monetarySettings?.symbol !== "£") currencyValue = currencyValue.replace(".", ",");

  return currencyValue;
};

export default generateCurrencyValue;
